import { render, staticRenderFns } from "./SelectCoverage.vue?vue&type=template&id=3a09bcac&scoped=true&"
import script from "./SelectCoverage.vue?vue&type=script&lang=js&"
export * from "./SelectCoverage.vue?vue&type=script&lang=js&"
import style0 from "./SelectCoverage.vue?vue&type=style&index=0&id=3a09bcac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a09bcac",
  null
  
)

export default component.exports